const MNTN_ACCOUNT_ID = (
  process.env.REACT_APP_MNTN_ACCOUNT_ID || ''
).trim();

export function fireMntnConversion({
  conversionType = 'purchase',
  orderId = '',
  orderAmount = '',
} = {}) {
  if (typeof document === 'undefined') {
    return false;
  }

  if (!MNTN_ACCOUNT_ID || !orderId) {
    return false;
  }

  const existing = document.querySelector(
    '[data-mntn-conversion-pixel]'
  );

  if (existing) {
    return false;
  }

  const referrer = encodeURIComponent(
    document.referrer?.substring(0, 512) || ''
  );

  const pageUrl = encodeURIComponent(
    window.location.href.substring(0, 512)
  );

  const cacheBuster = Math.floor(
    Math.random() * 100000000000000000
  );

  const scriptUrl =
    'https://dx.mountain.com/spx?' +
    'conv=1' +
    `&shaid=${MNTN_ACCOUNT_ID}` +
    `&tdr=${referrer}` +
    `&plh=${pageUrl}` +
    `&cb=${cacheBuster}` +
    `&shoid=${encodeURIComponent(orderId)}` +
    `&shoamt=${encodeURIComponent(orderAmount)}` +
    '&shocur=' +
    '&shopid=' +
    '&shoq=' +
    '&shoup=' +
    '&shpil=';

  const script = document.createElement('script');

  script.type = 'text/javascript';
  script.src = scriptUrl;
  script.setAttribute(
    'data-mntn-conversion-pixel',
    'true'
  );

  document.head.appendChild(script);

  return true;
}